<template>
    <div class="p-1">
        <h3>{{$safe(value,'EmployeeFullName') || '---'}}</h3>
        <hr/>
        <div class="border rounded p-75">
            <h6 class="text-muted">İletişim</h6>
            <template v-if="$safe(value,'RelativeFullName')">
                <h6>{{$safe(value,'RelationDegree')}} | {{$safe(value,'RelativeFullName')}}</h6>
                <h4 class="mb-0">{{$safe(value,'RelativePhoneNumber')}}</h4>
            </template>
            <template v-else>
                <h6>İletişim bilgisi bulunmamaktadır.</h6>
            </template>
        </div>
        <div class="border rounded p-75 mt-1" v-if="(callableExcuses || []).length">
            <h6 class="text-muted">İzinden Çağır</h6>
            <ul class="list-group">
                <li class="list-group-item p-50 d-flex align-items-center justify-content-between" v-for="(e,i) in callableExcuses" :key="i">
                    <span>
                        <span class="text-secondary font-weight-bolder">{{$safe(e,'Day')}}</span> | {{$safe(e,'Excuse.EmployeeExcuseType.Name')}}
                    </span>
                    <button v-on:click="endExcuse(e,i)"
                    v-b-tooltip.noninteractive.hover.left title="İzinden Çağır" class="btn btn-xs btn-icon btn-outline-primary ml-auto">
                            <b-spinner v-if="eIndex == i && excuseEnding" small></b-spinner>
                            <feather-icon v-else icon="CornerRightDownIcon"></feather-icon>
                        </button>
                </li>
            </ul>
        </div>
        <div class="border rounded p-75 mt-1">
            <h6 class="text-muted">İzin Oluştur</h6>
            <daily-score-excuse v-model="excuse"></daily-score-excuse>
            <div class="text-right mt-75">
                <v-executer class="btn-sm" :loading="excuseSaving" text="Oluştur" :action="createExcuse"></v-executer>
            </div>
        </div>
    </div>
</template>

<script>
import DailyScoreExcuse from './DailyScoreExcuse.vue'
import { VBTooltip, BSpinner } from 'bootstrap-vue'
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations' 
import Additional from '@/utilities/additional'

export default {
    components:{
        DailyScoreExcuse,
        BSpinner
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        value:{
            type:Object,
            default:()=>({})
        }
    },
    data(){
        return {
            excuseSaving:false,
            excuseEnding:false,
            eIndex:-1,
            excuse:{
                Id:null,
                EmployeeId:null,
                EmployeeFullName:null,
                ExcuseTypeId:null,
                RequestDate:null,
                StartDateTime:null,
                EndDateTime:null,
                Description:null,
                Approved:true,
                Document:null,
                JobStartDateTime:null,
            }
        }
    },
    methods:{
        clearForm(){
            this.excuse.Id = null
            this.excuse.EmployeeId = null
            this.excuse.EmployeeFullName = null
            this.excuse.ExcuseTypeId = null
            this.excuse.RequestDate = null
            this.excuse.StartDateTime = null
            this.excuse.EndDateTime = null
            this.excuse.Description = null
            this.excuse.Approved = true
            this.excuse.Document = null
            this.excuse.JobStartDateTime = null
        },
        async createExcuse(){
            this.excuseSaving = true
            this.excuse.EmployeeId = this.value.EmployeeId
            let formData = await Additional.ToFormData(this.excuse,['Document'])
            EmployeeOperationsApi.Excuse.CreateOrUpdate(formData).then(res=>{
                this.$result(res)
                this.excuseSaving = false
                if(res.data.Success){
                    this.$emit("refresh")
                }
            }).catch(err=>{
                this.excuseSaving = false
                this.$result(null,err)
            })
        },
        endExcuse(item,index){
            const currentDate = item.Day 
                ? moment(item.Day,'DD.MM.YYYY').format('YYYY-MM-DD')
                : moment().subtract(1,'day').format('YYYY-MM-DD')

            this.$confirm('İzinden çağırmak istediğinize emin misiniz?',`Bu işlem ${this.value.EmployeeFullName} isimli personeli izinden çağıracaktır ve geri alınamaz.`).then(result=>{
                if(result){
                    if(item.Excuse?.Id){
                        this.eIndex = index
                        this.excuseEnding = true
                        EmployeeOperationsApi.Excuse.End(item.Excuse.Id,currentDate).then(res=>{
                            this.$result(res)
                            this.excuseEnding = false
                            this.eIndex = null
                            if(res.data.Success){
                                this.$emit('excuse-end')
                                this.$emit('refresh')
                            }
                        }).catch(err=>{
                            this.$result(null,err)
                            this.excuseEnding = false
                            this.eIndex = null
                        })
                    }
                }
            })
        },
    },
    computed:{
        callableExcuses(){
            if(this.value?.Days){
                return Object.entries(this.value.Days).map(([key,value])=>({Day:key,...value})).filter(d=>d.Editable && d.Excuse != null)
            }else return []
        }
    },
}
</script>

<style>

</style>